import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import Vue from 'vue'
class WebSocketService {
  constructor() {
    this.stompClient = null
    this.connected = false
    this.messageCallback = null
    this.reconnectTimer = null
  }

  // 连接WebSocket
  connect(callback) {
    // 如果已经连接，不要重复连接
    if (this.connected) return
    console.log(globalConfig.thirdRootUrl,'rootUrl')
    const socket = new SockJS(globalConfig.thirdRootUrl + '/qyweixin/ws-chat')
    this.stompClient = Stomp.over(socket)
    
    // 可选：关闭调试日志
    // this.stompClient.debug = null
    // this.stompClient.debug = (str) => {
    //   if (str.includes('RECEIVE')) {
    //     console.log('收到服务器消息:', str)
    //   } else if (str.includes('SEND')) {
    //     console.log('发送到服务器:', str)
    //   } else if (str.includes('SUBSCRIBE')) {
    //     console.log('订阅请求:', str)
    //   } else {
    //     console.log('STOMP:', str)
    //   }
    // }
    this.stompClient.connect({}, (frame) => {
      // console.log('连接成功',frame)
      this.connected = true
      this.updateConnectionStatus(true)
      // 订阅统计数据更新
      this.stompClient.subscribe('/topic/chat', (message) => {
        // 执行的操作
        // console.log('收到消息:', message)
        
        // 如果有回调函数，调用它
        if (this.messageCallback) {
          this.messageCallback(message)
        }
        
        // 如果传入了callback参数，也调用它
        if (callback) {
          callback(message)
        }
      })
      
      // 请求初始数据
      this.stompClient.send("/app/request-stats", {}, JSON.stringify({}))
      
    }, (error) => {
      console.log('Error: ' + error)
      this.connected = false
      this.updateConnectionStatus(false)
      
      // 清除之前的定时器
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer)
      }
      
      // 5秒后重试
      this.reconnectTimer = setTimeout(() => {
        console.log('重试...')
        this.connect(callback)
      }, 5000)
    })
  }

  // 更新连接状态（可以在Vue组件外部调用）
  updateConnectionStatus(status) {
    // 可以在这里添加全局状态管理的逻辑
    console.log('连接状态为:', status ? '连接成功' : '断开连接')
    Vue.prototype.$eventBus.$emit('ws-connected', status)
  }

  // 设置消息接收回调
  onMessageReceived(callback) {
    this.messageCallback = callback
  }

  // 发送消息
  sendMessage(destination, body = {}) {
    if (this.stompClient && this.connected) {
      this.stompClient.send(destination, {}, JSON.stringify(body))
    } else {
      console.error('WebSocket is not connected')
    }
  }

  // 断开连接
  disconnect() {
    if (this.stompClient && this.connected) {
      this.stompClient.disconnect(() => {
        console.log('断开连接')
        this.connected = false
      })
    }
    
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = null
    }
  }
}

// 创建单例
const websocketService = new WebSocketService()
export default websocketService